import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { ContabilidadProvider, ContabilidadContext } from './ContabilidadContext';

const Header = ({ title }) => {
  const { selectedCompany, openCompanySelector } = useContext(ContabilidadContext);

  useEffect(() => {
    // Si no hay empresa seleccionada y el contexto ya montó, se podría abrir el selector,
    // pero eso lo manejamos mejor desde un useEffect centralizado en un wrapper o botón
    if (!selectedCompany) {
      // Small timeout to prevent state update during render
      const timer = setTimeout(() => {
          openCompanySelector();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [selectedCompany, openCompanySelector]);

  return (
    <Card className="mb-3 bg-white shadow-sm border-0">
      <Card.Body className="py-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {title && (
              <h5 className="mb-0 text-primary fw-bold d-flex align-items-center">
                {title}
              </h5>
            )}
          </div>
          <div className="d-flex align-items-center text-secondary" style={{ fontSize: '0.95rem' }}>
            <i className="fa fa-building me-2 text-primary"></i>
            <span className="fw-bold text-dark">{selectedCompany ? selectedCompany.vRFC : 'N/A'}</span>
            <span className="mx-2 text-muted">|</span>
            <span className="text-dark">{selectedCompany ? selectedCompany.vRazonSocial : 'Ninguna Empresa Seleccionada'}</span>
            
            <button 
              className="btn btn-sm btn-outline-primary ms-3 px-3 rounded-pill fw-bold" 
              onClick={openCompanySelector}
              title="Cambiar Empresa"
            >
              Cambiar
            </button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export const ContabilidadLayout = ({ children, title }) => {
  return (
    <ContabilidadProvider>
      <div className="contabilidad-layout-container">
        <Header title={title} />
        {children}
      </div>
    </ContabilidadProvider>
  );
};

Header.propTypes = {
  title: PropTypes.node
};

ContabilidadLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node
};
